module.exports = __webpack_public_path__ + "static/media/screen-mini.b59f671c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/features/screen-mini.svg
// module id = 129
// module chunks = 0